const isDisruption = (disruption) => !!(typeof disruption === "object" && disruption.id && disruption.message);
var isDisruption_default = isDisruption;
export {
  isDisruption_default as default
};
